import axios from 'axios';
// Local service endpoints in two ways:
// To use both local TAPI and local photos service, set the env argument
// to Environment.local or set useLocalTApi and useLocalPhotosService to true
// To use only one of the local TAPI or local photos services use the 'useLocalTApi'
// or 'useLocalPhotosService' arguments
export var Environment;
(function (Environment) {
    Environment["staging"] = "STAGING";
    Environment["prod"] = "PROD";
    Environment["production"] = "PRODUCTION";
    Environment["qa"] = "QA";
    Environment["dev"] = "DEV";
    Environment["local"] = "LOCAL";
})(Environment || (Environment = {}));
export const TApiEndpoints = {
    [Environment.staging]: 'https://tapi-staging.zicasso.com',
    [Environment.prod]: 'https://tapi.zicasso.com',
    [Environment.production]: 'https://tapi.zicasso.com',
    [Environment.qa]: 'https://tapi-qa.zicasso.com',
    [Environment.dev]: 'https://tapi-qa.zicasso.com',
    [Environment.local]: 'http://localhost:8080', // set manually in client app to use local TAPI
};
export const PhotoServiceEndpoints = {
    [Environment.staging]: 'https://api-photos.zicasso.com',
    [Environment.prod]: 'https://api-photos.zicasso.com',
    [Environment.production]: 'https://api-photos.zicasso.com',
    [Environment.qa]: 'https://api-photos.zicasso.com',
    [Environment.dev]: 'https://api-photos.zicasso.com',
    [Environment.local]: 'http://localhost:8300', // set manually in client app to use local photos service
};
const handleResponse = (response) => response.data;
const handleResponseError = (error) => {
    let aE;
    if (error.response) {
        aE = error.response.data;
    }
    else if (error.request) {
        aE = {
            code: error.request.status,
            message: error.request.statusText,
        };
    }
    else {
        aE = {
            message: error.message,
        };
    }
    return Promise.reject(aE);
};
export default class DefaultApiClient {
    constructor(env, token, axiosConfig, useLocalTApi, useLocalPhotosService) {
        this.authToken = '';
        const environment = env || Environment.dev;
        this.axios = axios.create(Object.assign({ baseURL: useLocalTApi ? TApiEndpoints[Environment.local] : TApiEndpoints[environment], responseType: 'json' }, axiosConfig));
        // Photos Service is public, no token needed
        this.axiosPhotos = axios.create(Object.assign({ baseURL: useLocalPhotosService ? PhotoServiceEndpoints[Environment.local] : PhotoServiceEndpoints[environment], responseType: 'json' }, axiosConfig));
        if (token)
            this.setAuthToken(token);
    }
    setAuthToken(token) {
        this.authToken = token;
        this.axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    }
    getAuthToken() {
        return this.authToken;
    }
    // TApi request methods
    get(url, config) {
        return this.axios.get(url, config).then(handleResponse).catch(handleResponseError);
    }
    post(url, data, config) {
        return this.axios.post(url, data, config).then(handleResponse).catch(handleResponseError);
    }
    put(url, data, config) {
        return this.axios.put(url, data, config).then(handleResponse).catch(handleResponseError);
    }
    patch(url, data, config) {
        return this.axios.patch(url, data, config).then(handleResponse).catch(handleResponseError);
    }
    delete(url, config) {
        return this.axios.delete(url, config).then(handleResponse).catch(handleResponseError);
    }
    exists(url, config) {
        return this.axios
            .head(url, config)
            .then((response) => response.status === 200)
            .catch(() => false);
    }
    // Photo Service request methods
    getPhotos(url, config) {
        return this.axiosPhotos.get(url, config).then(handleResponse).catch(handleResponseError);
    }
    postPhotos(url, data, config) {
        return this.axiosPhotos.post(url, data, config).then(handleResponse).catch(handleResponseError);
    }
}
